import { useAtomValue, useSetAtom } from "jotai";
import { atomWithImmer } from "jotai-immer";
import { selectAtom } from "jotai/utils";

interface PosOrderSearchProps {
  text: string;
  barcode: string;
}

export const defaultPosOrderSearch: PosOrderSearchProps = {
  text: "",
  barcode: ""
};

const posOrderSearchAtom = atomWithImmer(defaultPosOrderSearch);

const textAtom = selectAtom(posOrderSearchAtom, (state) => state.text);
const barcodeAtom = selectAtom(posOrderSearchAtom, (state) => state.barcode);

export const useSearchText = () => useAtomValue(textAtom);
export const useSearchBarcode = () => useAtomValue(barcodeAtom);

export const useSetPosOrderSearch = () => useSetAtom(posOrderSearchAtom);
